export function joinRoute(...routes: string[]): string {
  return `${routes.join('/').replace(/\/{2,}/, '/')}`;
}
